import { defineMessages } from 'react-intl';

export default defineMessages({
  FirstNameInputValidationMessage: {
    id: 'FirstNameInput.Errors.InvalidMessage',
    defaultMessage: 'Invalid first name',
  },
  LastNameInputValidationMessage: {
    id: 'LastNameInput.Errors.InvalidMessage',
    defaultMessage: 'Invalid last name',
  },
  OptionalResumeMessage: {
    id: 'PersonalSection.Profile.OptionalResumeMessage',
    defaultMessage: 'Please provide at least one item below to proceed.',
  },
  OptionalResumeValidationMessage: {
    id: 'PersonalSection.Profile.OptionalResumeValidationMessage',
    defaultMessage: 'At least one of these items is required.',
  },
  PhoneInputValidationMessage: {
    id: 'PhoneInput.Errors.InvalidMessage',
    defaultMessage: 'Invalid telephone number',
  },
});
